import { HttpRequest, HttpEvent, HttpHandlerFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { isApiRequest, isAuthSessionRequest } from '../_helpers/api-request';
import { AuthenticationService } from '../_services/authentication/authentication.service';

export function authInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  if (!isApiRequest(req.url)) return next(req);

  const withCurrentCredentials = () => {
    const accessToken = localStorage.getItem('access_token');
    return req.clone({
      withCredentials: true,
      setHeaders: accessToken
        ? {
            Authorization: `Bearer ${accessToken}`,
          }
        : {},
    });
  };
  const securedRequest = withCurrentCredentials();
  // Refresh must bypass recovery to avoid recursively refreshing itself.
  if (isAuthSessionRequest(req.url)) return next(securedRequest);

  const auth = inject(AuthenticationService);
  const router = inject(Router);

  return next(securedRequest).pipe(
    catchError((error) => {
      if (error.status !== 401 || !auth.hasStoredSession()) {
        return throwError(() => error);
      }
      return auth.refreshToken().pipe(
        catchError((refreshError) => {
          if (refreshError.status === 401) router.navigate(['']);
          return throwError(() => refreshError);
        }),
        // Retry only the rejected request, once, with the newly stored token.
        switchMap(() => next(withCurrentCredentials())),
      );
    }),
  );
}
